import React, { useEffect, useRef } from 'react';
import { getSearchPhraseFromStorage } from 'components/common/SearchInput/helpers';
import { EntityLabel } from 'components/common/SearchInput/types';

export const useInitialSearchEffect = (
  projectId: string,
  entityLabel: EntityLabel,
  setSearchPhrase: (phrase: string) => void
): void => {
  const setSearchPhraseRef = useRef(setSearchPhrase);
  setSearchPhraseRef.current = setSearchPhrase;

  useEffect(() => {
    const phrase = getSearchPhraseFromStorage(projectId, entityLabel);
    setSearchPhraseRef.current(phrase);

    return (): void => {
      setSearchPhraseRef.current('');
    };
  }, [projectId, entityLabel]);
};
